import React, { Fragment, useState, useEffect } from "react";
import Topbar from "../layouts/TopBar";
import UserResources from "../resources/UserResources";
import { toast } from "react-toastify";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import moment from "moment";
import { connect } from "react-redux";

function TeamDistribution({isLoggedIn, loggedInUser}){

    const [users, setUsers] = useState([])
    const [LPUsers, setLPUsers] = useState([])
    const [NLUsers, setNLUsers] = useState([])
    const [CWUsers, setCWUsers] = useState([])
    const [CRYUsers, setCRYUsers] = useState([])
    


    const loadUsers = () => {
        let resources = new UserResources()
        return resources.get_non()
    }

    useEffect(() => {
        loadUsers().then(response => { 
            setUsers(response['body']); 
            setNLUsers(response['body'].filter(user => user['location.name'] === 'North London' )); 
            setCWUsers(response['body'].filter(user => user['location.name'] === 'Canary Wharf' )); 
            setLPUsers(response['body'].filter(user => user['location.name'] === 'Liberty Point' )); 
            setCRYUsers(response['body'].filter(user => user['location.name'] === 'Croydon' ));
        }).catch((err) => {
            toast.error("Network error: " + err)
        });
    }, []);


    return(
        <Fragment>
            <Topbar/>

            <div className="hero-area">
            <div className="page-banner parallax" style={{backgroundColor:"#003165"}}>
                    <div className="container">
                        <div className="page-banner-text">
                            <h1 style={{color:"#ffa800"}} className="block-title"><strong>Team Distribution</strong></h1>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
        	<div className="container">

                <div className="spacer-40"></div>

                {[
                    { label: 'Liberty Point', users: LPUsers },
                    { label: 'Canary Wharf', users: CWUsers },
                    { label: 'North London', users: NLUsers },
                    { label: 'Croydon', users: CRYUsers }
                ].map((location) => (
                    <div key={location.label} style={{marginBottom: '40px'}}>
                        <div style={{backgroundColor: '#003165', borderRadius: '10px', padding: '16px 24px', marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '12px'}}>
                            <span style={{color: '#fff', fontSize: 'clamp(11px, 3vw, 13px)', textTransform: 'uppercase', letterSpacing: '1px'}}>Team at</span>
                            <h3 style={{color: '#ffa800', margin: 0, fontSize: 'clamp(18px, 4vw, 24px)'}}>{location.label}</h3>
                            <span style={{backgroundColor: '#ffa800', color: '#003165', fontSize: 'clamp(11px, 3vw, 12px)', fontWeight: 'bold', borderRadius: '12px', padding: '2px 10px', marginLeft: 'auto'}}>{location.users.length} {location.users.length === 1 ? 'member' : 'members'}</span>
                        </div>

                        {location.users.length === 0 ? (
                            <p style={{color: '#999', fontStyle: 'italic', padding: '0 8px'}}>No members at this location.</p>
                        ) : (
                            <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '16px'}}>
                                {location.users.map((member, index) => (
                                    <div key={index} style={{backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e0e0e0', padding: '20px 12px', textAlign: 'center', width: '160px', flexShrink: 0}}>
                                        {isLoggedIn ? (
                                            <a href={"/memberprofile?pid=3&mot=ia293b" + member['id'] + "&intra=zfa5s"} style={{textDecoration: 'none'}}>
                                                <div style={{width: '100px', height: '100px', borderRadius: '50%', overflow: 'hidden', margin: '0 auto 10px', border: '3px solid #ffa800', cursor: 'pointer'}}>
                                                    <img src={member['image']} style={{width: '100%', height: '100%', objectFit: 'cover'}} alt=""/>
                                                </div>
                                            </a>
                                        ) : (
                                            <div style={{width: '100px', height: '100px', borderRadius: '50%', overflow: 'hidden', margin: '0 auto 10px', border: '3px solid #ffa800'}}>
                                                <img src={member['image']} style={{width: '100%', height: '100%', objectFit: 'cover'}} alt=""/>
                                            </div>
                                        )}
                                        {isLoggedIn ? (
                                            <a href={"/memberprofile?pid=3&mot=ia293b" + member['id'] + "&intra=zfa5s"} style={{color: '#ffa800', fontWeight: 'bold', textDecoration: 'none', fontSize: 'clamp(13px, 3.5vw, 14px)'}}>{member['firstname'] + " " + member['lastname']}</a>
                                        ) : (
                                            <p style={{color: '#ffa800', fontWeight: 'bold', margin: 0, fontSize: 'clamp(13px, 3.5vw, 14px)'}}>{member['firstname'] + " " + member['lastname']}</p>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}

            </div>
            </div>

        </Fragment>
    )
}

const mapStateToProps = (state) => {
    return{
       isLoggedIn: state.authReducer.isLoggedIn,
       loggedInUser: state.authReducer.user
    };
    
};

export default connect(mapStateToProps)(TeamDistribution);